import CommonMemberTable from "../commonModule/CommonMemberTable";

const PendingMemberTable = () => {
  return <CommonMemberTable status="pending" title="Pending members" />;
};

export default PendingMemberTable;
